import PropTypes from "prop-types";
import {roundAmount} from "../utils/money";
import {GramsPerWeightUnit, MilliLitresPerVolumeUnit} from "../Product/units";

const NormalisedQuantityDisplay = ({normalisedQuantity, unit}) => {
  if (normalisedQuantity === null || unit === null) return null;
  const amount = normalisedQuantity / NormalisedUnitFactor[unit];
  return roundAmount(amount, 1).toString() + ' ' + unit;
};

NormalisedQuantityDisplay.propTypes = {
  normalisedQuantity: PropTypes.number,
  unit: PropTypes.string,
};

NormalisedQuantityDisplay.defaultProps = {
  normalisedQuantity: null,
  unit: null,
};

export default NormalisedQuantityDisplay;

export const NormalisedUnitFactor = Object.freeze({
  ...GramsPerWeightUnit,
  ...MilliLitresPerVolumeUnit,
  'each': 1,
});

export const NormalisedUnitForClass = Object.freeze({
  'weight': 'g',
  'volume': 'mL',
  'each': 'each',
});



// WEBPACK FOOTER //
// ./src/BulkConsignment/NormalisedQuantityDisplay.js